import { useTranslation } from '../../i18n';
import { isNews } from '../../utils/isNews';
import { container, text, buzzfeed_news, learnMoreLink, containerClassic, textClassic } from './commerce-disclaimer.module.scss';

const ETHICS_GUIDE_URL = 'https://www.buzzfeed.com/buzzfeedstaff/buzzfeed-standards-ethics-guide';
const DISCLOSURE_TEXT = 'BuzzFeed and our publishing partners may collect a share of sales or other compensation from the links on this page.';

function CommerceDisclaimer({ buzz }) {
  const { t } = useTranslation('common');
  const filterId = `commerce-disclaimer-shadow-${buzz.id || 'default'}`;
  let message = 'commerce_disclaimer';

  if (!buzz.isShopping && !buzz.tags.some(tag => tag.match('--commerce-disclaimer'))) {
    return null;
  }

  // For non-english editions, use translated commerce-disclaimer, not news specific one
  if (isNews(buzz) && buzz.language === 'en') {
    message = 'commerce_disclaimer_news';
  }

  const isUSShoppingPost = buzz.isShopping && buzz.country_code === 'en-us';

  // Non-US: render original simple disclaimer
  if (!isUSShoppingPost) {
    return (
      <div className={containerClassic}>
        <p
          className={`${textClassic} ${isNews(buzz) ? buzzfeed_news : ''}`}
          dangerouslySetInnerHTML={{ __html: t(message) }}
        />
      </div>
    );
  }

  return (
    <div className={container}>
      <svg
        className="disclaimer-shape"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1272 76"
        preserveAspectRatio="none"
        aria-hidden="true"
        focusable="false"
      >
        <defs>
          <filter id={filterId} x="0" y="0" width="1272" height="76" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
            <feFlood floodOpacity="0" result="BackgroundImageFix"/>
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
            <feOffset/>
            <feGaussianBlur stdDeviation="5"/>
            <feComposite in2="hardAlpha" operator="out"/>
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"/>
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_286_2556"/>
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_286_2556" result="shape"/>
          </filter>
        </defs>
        <path d="M10 62.6534L38.0822 10H1194.13L1262 14.0159V66H115.308L10 62.6534Z" fill="white" filter={`url(#${filterId})`}/>
      </svg>
      <div className="disclaimer-content">
        <p className={text}>
          {DISCLOSURE_TEXT}
          {' '}
          <a href={ETHICS_GUIDE_URL} className={learnMoreLink} rel="noopener noreferrer">
            Read More
          </a>
        </p>
      </div>
    </div>
  );
}

export default CommerceDisclaimer;
